/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InstallationsRouteImport } from './routes/installations'
import { Route as ActionsRouteImport } from './routes/actions'
import { Route as IndexRouteImport } from './routes/index'

const InstallationsRoute = InstallationsRouteImport.update({
  id: '/installations',
  path: '/installations',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionsRoute = ActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/installations': typeof InstallationsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/installations': typeof InstallationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/installations': typeof InstallationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/actions' | '/installations'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/actions' | '/installations'
  id: '__root__' | '/' | '/actions' | '/installations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActionsRoute: typeof ActionsRoute
  InstallationsRoute: typeof InstallationsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/installations': {
      id: '/installations'
      path: '/installations'
      fullPath: '/installations'
      preLoaderRoute: typeof InstallationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actions': {
      id: '/actions'
      path: '/actions'
      fullPath: '/actions'
      preLoaderRoute: typeof ActionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActionsRoute: ActionsRoute,
  InstallationsRoute: InstallationsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
